var angular = require('angular');
var _module = angular.module('benoit', []);

module.exports = _module;
